var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.19873H2.6H15.4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7994 4.2V15.4C13.7994 15.8243 13.6308 16.2313 13.3307 16.5314C13.0307 16.8314 12.6237 17 12.1994 17H4.19937C3.77502 17 3.36805 16.8314 3.06799 16.5314C2.76794 16.2313 2.59937 15.8243 2.59937 15.4V4.2M4.99937 4.2V2.6C4.99937 2.17565 5.16794 1.76869 5.46799 1.46863C5.76805 1.16857 6.17502 1 6.59937 1H9.79937C10.2237 1 10.6307 1.16857 10.9307 1.46863C11.2308 1.76869 11.3994 2.17565 11.3994 2.6V4.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 8.2002V13.0002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 8.2002V13.0002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTrash);
export default __webpack_public_path__ + "static/media/icn-trash.25d3db3c45c341ca82288edaf5112ae4.svg";
export { ForwardRef as ReactComponent };